import { Button, HStack } from '@chakra-ui/react'

interface QuestionCarouselNavigationProps {
  isNextDisabled: boolean
  isPreviousDisabled: boolean
  onNext: () => void
  onPrevious: () => void
}

export default function QuestionCarouselNavigation({
  isNextDisabled,
  isPreviousDisabled,
  onNext,
  onPrevious,
}: QuestionCarouselNavigationProps) {
  return (
    <HStack justify='space-between'>
      <Button
        colorScheme='purple'
        isDisabled={isPreviousDisabled}
        onClick={onPrevious}
        type='button'
        variant='outline'
      >
        ← Previous question
      </Button>
      <Button
        colorScheme='purple'
        isDisabled={isNextDisabled}
        onClick={onNext}
        type='button'
      >
        Next question →
      </Button>
    </HStack>
  )
}
